<template>
  <div class="AddRecommendationAction">
    <div class="container-fluid padding-right-0Px padding-left-0px">

      <div class="row vertical-align margin-bottom-2Perc">
        <div
          class="create-element-overlay-course-title-font-styles font-weight-bold col-md-12 col-lg-12 padding-left-0px padding-right-0Px">
          <u>Add To Recommendations</u>
        </div>
      </div>

      <div class="row vertical-align margin-bottom-2Perc text-align-left">
        <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-left-0px padding-right-0Px">
          Group
        </div>
        <div class="col-md-4 col-lg-4 padding-right-0Px">
          <select class="form-control" v-model="getSelectedGroupObj">
            <option value='-1' disabled>Select</option>
            <option v-for="groupObj in getGroupList" v-bind:key="groupObj.GroupId" v-bind:value="groupObj" v-if="!hasAlreadySelectedGroup(groupObj)">{{ groupObj.GroupName }}</option>
          </select>
        </div>
        <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-left-0px padding-right-0Px" v-if="getSelectedGroupObj !== -1">
        </div>
        <div class="col-md-4 col-lg-4 padding-right-0Px">
        </div>
      </div>

      <div class="row vertical-align margin-bottom-2Perc text-align-left">
        <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-left-0px padding-right-0Px" v-if="getSelectedGroupObj !== -1">
          Elective Courses
        </div>
        <div class="col-md-9 col-lg-9 padding-right-0Px">
          <div v-for="groupElectiveObj in electivesList" :key="groupElectiveObj.GroupCourseMasterId">
            <input type="checkbox" :value="groupElectiveObj.GroupCourseMasterId" :name="`${groupElectiveObj.CourseTitle} [${groupElectiveObj.CourseSubTitle}]`" v-model="getSelectedGroupCourseArr">
            <label style="margin-left: 0.2em; font-weight: normal;" :for="`${groupElectiveObj.CourseTitle} [${groupElectiveObj.CourseSubTitle}]`">{{ `${groupElectiveObj.CourseTitle} [${groupElectiveObj.CourseSubTitle}]` }}</label>
          </div>
          <div v-if="getSelectedGroupObj !== -1 && electivesList.length === 0">
            <b>Not Found.</b>
          </div>
        </div>
        <div class="col-md-1 col-lg-1">
        </div>
      </div>

      <div class="row vertical-align margin-bottom-2Perc text-align-left">
        <div class="col-md-5 col-lg-5"></div>
        <div class="col-md-2 col-lg-2">
          <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" :disabled="localContentIdsArr.length === 0" @click="emitToParent">Add</button>
        </div>
        <div class="col-md-5 col-lg-5"></div>
      </div>
      <div class="row">
        <div class="table-responsive margin-Top-6Perc overflowXHidden" v-if="currSessionActionMetaObjList.length > 0">
          <table class="table table-striped">
            <thead>
              <tr>
                <th class="text-align-center font-size-15px border-right">Sr. No.</th>
                <th class="text-align-center font-size-15px border-right">Group</th>
                <th class="text-align-center font-size-15px border-right">Course(s)</th>
                <th class="text-align-center font-size-15px">Action</th>
              </tr>
            </thead>
            <tbody class="font-size-15px">
              <tr v-for="(actionMetaObj, index) in currSessionActionMetaObjList" :key="actionMetaObj.GroupName" v-bind:actionMetaObj="actionMetaObj" class="text-align-left font-size-15px">
                <td class="border-right text-align-center">{{index + 1}}.</td>
                <td class="border-right text-align-center">{{actionMetaObj.GroupName}}</td>
                <td class="border-right">
                  <span v-for="(courseTitleName, index) in actionMetaObj.CourseTitles" :key="index">
                    {{'- ' + courseTitleName}}<br/>
                  </span>
                </td>
                <td class="text-align-center">
                  <a class="cursor-pointer" @click="performSelectedAction(actionMetaObj, 'delete')">Delete</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>  
    </div>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
  </div>

</template>

<script>
import AlertBox from '@/components/AlertOverlay'
import { constants } from '../../utils/constants'
import { groupCourseService } from '@/server-util/group-course-service'
import { find, isEmpty, isNull, forEach, filter, findIndex } from 'lodash'
import { groupService } from '@/server-util/group-service'

export default {
  props: ['lessonObj', 'ElementObj', 'selectedRuleObj', 'selectedActionRuleObj'],
  created: function () {
    this.getGroups()
    this.getElectivesGroups()
  },
  name: 'AddRecommendationAction',
  data: function () {
    return {
      globalElectiveList: [],
      currSessionActionMetaObjList: [],
      constants: constants,
      showAlertDialog: false,
      errorMsg: '',
      electivesList: [],
      localContentIdsArr: [],
      selectedGroupObj: -1,
      objToReturn: {
        ActionMasterId: this.selectedActionRuleObj.ActionMasterId,
        ActionType: this.selectedActionRuleObj.ActionName,
        objToPush: {}
      }
    }
  },
  methods: {
    hasAlreadySelectedGroup: function (groupObj) {
      const foundIndex = findIndex(this.currSessionActionMetaObjList, (obj) => {
        return obj.GroupId === groupObj.GroupId
      })
      return foundIndex > -1
    },
    performSelectedAction: function (currActionMetaObj, actionName) {
      switch (actionName) {
        case 'delete':
          // AK: Rebind again same object by removing current selected group
          this.objToReturn.objToPush = {}
          forEach(this.currSessionActionMetaObjList, (obj) => {
            if (obj.GroupId !== currActionMetaObj.GroupId) {
              var actionMetaObjToReturn = {
                GroupId: obj.GroupId,
                GroupName: obj.GroupName,
                ContentType: 0,
                CourseTitles: obj.CourseTitles,
                ContentIds: obj.ContentIds
              }
              this.objToReturn.objToPush[obj.GroupId] = actionMetaObjToReturn
            }
          })
          // AK: Removed from listing as well
          this.currSessionActionMetaObjList = filter(this.currSessionActionMetaObjList, (obj) => {
            return obj.GroupId !== currActionMetaObj.GroupId
          })
          console.log('Delete Operation >>> this.objToReturn: ' + JSON.stringify(this.objToReturn))
          this.$emit('selectedValues', this.objToReturn)
          // console.log('currActionMetaObj.GroupId:' + JSON.stringify(this.objToReturn.objToPush[currActionMetaObj.GroupId]))
          break
      }
    },
    emitToParent: function () {
      var groupIdLocal = this.getSelectedGroupObj.GroupId
      var actionMetaObjToReturn = {
        GroupId: groupIdLocal,
        GroupName: this.getSelectedGroupObj.GroupName,
        ContentType: 0,
        CourseTitles: [],
        ContentIds: this.localContentIdsArr
      }
      forEach(this.localContentIdsArr, (groupCourseMasterId) => {
        const currCourseObj = find(this.electivesList, (obj1) => {
          return groupCourseMasterId === obj1.GroupCourseMasterId
        })
        if (!isNull(currCourseObj) && !isEmpty(currCourseObj)) {
          actionMetaObjToReturn.CourseTitles.push(currCourseObj.CourseTitle + ' [' + currCourseObj.CourseSubTitle + ']')
        }
      })
      this.objToReturn.objToPush[groupIdLocal] = actionMetaObjToReturn
      this.currSessionActionMetaObjList.push(actionMetaObjToReturn)
      console.log('this.objToReturn: ' + JSON.stringify(this.objToReturn))
      this.$emit('selectedValues', this.objToReturn)
      this.resetValuesToDefault()
    },
    resetValuesToDefault: function () {
      this.selectedGroupObj = -1
      this.localContentIdsArr = []
    },
    getGroups: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined &&
        storeObj.state.access_token !== null &&
        storeObj.state.access_token !== ''
      ) {
        // AK: Check weather Grouplist is already present or not?
        if (storeObj.state.groupList.length === 0) {
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        } else {
          _this.groupList = storeObj.state.groupList
        }
        groupService.listGroups(storeObj.state.access_token).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupList = responseObj.data
              // AK: Hide Spinner after recieving group list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('Access Token is NULL hence declined LOADING GROUP LIST')
      }
    },
    checkAndShowElectiveCourseList: function () {
      let selectedGroupElectives = find(this.globalElectiveList, (obj) => {
        return obj.GroupId === this.getSelectedGroupObj.GroupId
      })
      if (!isNull(selectedGroupElectives) && !isEmpty(selectedGroupElectives)) {
        this.electivesList = selectedGroupElectives.GroupCourseList
      }
    },
    getElectivesGroups: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined &&
        storeObj.state.access_token !== null &&
        storeObj.state.access_token !== ''
      ) {
        _this.$store.state.isLoading = true
        groupCourseService.listElectivesGroups(storeObj.state.access_token, this.getSelectedGroupObj.GroupId).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.globalElectiveList = responseObj.data
              _this.checkAndShowElectiveCourseList()
              _this.$store.state.isLoading = false
            } else {
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // SS: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('Access Token is NULL hence declined LOADING GROUP ELECTIVE LIST')
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    }
  },
  components: {
    'alert-box': AlertBox
  },
  computed: {
    getGroupList: {
      get: function () {
        return this.$store.state.groupList
      },
      set: function (value) {
        this.$store.state.groupList = value
      }
    },
    getSelectedGroupCourseArr: {
      get: function () {
        return this.localContentIdsArr
      },
      set: function (value) {
        this.localContentIdsArr = value
      }
    },
    getSelectedGroupObj: {
      get: function () {
        return this.selectedGroupObj
      },
      set: function (newValue) {
        this.selectedGroupObj = newValue
      }
    }
  },
  watch: {
    getSelectedGroupObj: function (newValue, oldValue) {
      this.electivesList = []
      this.checkAndShowElectiveCourseList()
    }
  }
}
</script>

<style scoped>
.font-weight-bold-withOpacity75 {
  font-weight: bold;
  opacity: .75;
}
.cursor-default {
  cursor: default !important;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 5%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}

.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.text-align-left {
  text-align: left !important;
}
.text-align-center {
  text-align: center !important;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-21px {
  font-size: 21px;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 14px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 5%;
  height: 5%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 16px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
.padding-right-0px{
  padding-right: 0px !important;
}
.padding-left-0px{
  padding-left: 0px !important;
}
.font-size-12px{
  font-size: 12px;
}
.border-1px-solid-grey {
  border: 1px solid #aaa;
}
.border-top-1px-solid-grey {
  border-top: 1px solid #dadada;
}
.border-bottom-1px-solid-grey {
  border-bottom: 1px solid #dadada;
}
.margin-left-1Point5Perc
{
  margin-left:1.5%;
}
.margin-left-1Point6Perc
{
  margin-left:1.6%;
}
.border-red{
  border: 1px solid red;
}
.padding-left-30px{
  padding-left:30px;
}
.font-size-12px{
  font-size:12px;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.margin-Top-6Perc {
  margin-top: 6%;
}
.overflowXHidden {
  overflow-x: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/personalization_rule/AddRecommendationAction.vue